///<reference path="../ajaxQ/ajaxq.d.ts"/>
require("jquery");
require("../ajaxQ/ajaxq");
var Backbone = require("backbone");

Backbone.ajax = function() {
	return Backbone.$.ajaxDefaultQ.apply(Backbone.$, arguments);
};
